var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Roku {
    constructor(log) {
        this.apps = [
            { id: '683311', version: '10.3.17', name: 'Live TV Guide' },
            { id: '12', version: '5.2.130096002', name: 'Netflix' },
            { id: '13', version: '15.3.2024082810', name: 'Prime Video' },
            { id: '2285', version: '6.85.0', name: 'Hulu' },
            { id: '2213', version: '5.5.13', name: 'Roku Media Player' },
            { id: '551012', version: '14.4.42', name: 'Apple TV' },
        ];
        this.deviceInfo = [
            '<?xml version="1.0" encoding="UTF-8" ?>',
            '<device-info>',
            '<udn>28001000-0000-1000-8001-a8b57c4dce82</udn>',
            '<serial-number>X010001TLAMP</serial-number>',
            '<device-id>S0DA241TLAMP</device-id>',
            '<advertising-id>38dc3756-4331-5f2e-953e-5b78c2a0397b</advertising-id>',
            '<vendor-name>Roku</vendor-name>',
            '<model-name>Roku Ultra</model-name>',
            '<model-number>4802X</model-number>',
            '<model-region>US</model-region>',
            '<is-tv>false</is-tv>',
            '<is-stick>false</is-stick>',
            '<mobile-has-live-tv>true</mobile-has-live-tv>',
            '<ui-resolution>1080p</ui-resolution>',
            '<supports-ethernet>true</supports-ethernet>',
            '<wifi-mac>a8:b5:7c:4d:ce:82</wifi-mac>',
            '<wifi-driver>realtek</wifi-driver>',
            '<has-wifi-5G-support>true</has-wifi-5G-support>',
            '<ethernet-mac>a8:b5:7c:4d:ce:83</ethernet-mac>',
            '<bluetooth-mac>a8:b5:7c:4d:ce:84</bluetooth-mac>',
            '<network-type>ethernet</network-type>',
            '<friendly-device-name>Roku Ultra</friendly-device-name>',
            '<friendly-model-name>Roku Ultra</friendly-model-name>',
            '<default-device-name>Roku Ultra - X010001TLAMP</default-device-name>',
            '<user-device-name>Roku Ultra</user-device-name>',
            '<user-device-location>Lab</user-device-location>',
            '<build-number>C2E.14E01510A</build-number>',
            '<software-version>13.1.3</software-version>',
            '<software-build>1510</software-build>',
            '<lightning-base-build-number>xxE.00E240xxA</lightning-base-build-number>',
            '<ui-build-number>C2E.14E01510A</ui-build-number>',
            '<ui-software-version>13.1.4</ui-software-version>',
            '<ui-software-build>1510</ui-software-build>',
            '<secure-device>true</secure-device>',
            '<language>en</language>',
            '<country>US</country>',
            '<locale>en_US</locale>',
            '<time-zone-auto>true</time-zone-auto>',
            '<time-zone>US/Eastern</time-zone>',
            '<time-zone-name>United States/Eastern</time-zone-name>',
            '<time-zone-tz>America/New_York</time-zone-tz>',
            '<time-zone-offset>-240</time-zone-offset>',
            '<clock-format>12-hour</clock-format>',
            '<uptime>9100</uptime>',
            '<power-mode>PowerOn</power-mode>',
            '<supports-suspend>true</supports-suspend>',
            '<supports-find-remote>true</supports-find-remote>',
            '<find-remote-is-possible>true</find-remote-is-possible>',
            '<supports-audio-guide>true</supports-audio-guide>',
            '<supports-rva>true</supports-rva>',
            '<has-hands-free-voice-remote>true</has-hands-free-voice-remote>',
            '<developer-enabled>false</developer-enabled>',
            '<keyed-developer-id />',
            '<device-automation-bridge-enabled>false</device-automation-bridge-enabled>',
            '<search-enabled>true</search-enabled>',
            '<search-channels-enabled>true</search-channels-enabled>',
            '<voice-search-enabled>true</voice-search-enabled>',
            '<supports-private-listening>true</supports-private-listening>',
            '<headphones-connected>false</headphones-connected>',
            '<supports-audio-settings>false</supports-audio-settings>',
            '<supports-ecs-textedit>true</supports-ecs-textedit>',
            '<supports-ecs-microphone>true</supports-ecs-microphone>',
            '<supports-wake-on-wlan>false</supports-wake-on-wlan>',
            '<supports-airplay>true</supports-airplay>',
            '<has-play-on-roku>true</has-play-on-roku>',
            '<has-mobile-screensaver>false</has-mobile-screensaver>',
            '<support-url>roku.com/support</support-url>',
            '<grandcentral-version>12.1.17</grandcentral-version>',
            '<supports-trc>true</supports-trc>',
            '<trc-version>3.0</trc-version>',
            '<trc-channel-version>9.3.10</trc-channel-version>',
            '<av-sync-calibration-enabled>3.0</av-sync-calibration-enabled>',
            '</device-info>',
        ];
        this.asyncHandlers = [
            {
                name: 'media-player',
                path: /\/query\/media-player/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, '<?xml version="1.0" encoding="UTF-8" ?><player state="close" error="false" />');
                }),
            },
            {
                name: 'device-info',
                path: /\/query\/device-info/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, this.deviceInfo.join('\n\t'));
                }),
            },
            {
                name: 'query apps',
                path: /\/query\/apps/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, this.makeAppsResponse());
                }),
            },
            {
                name: 'keypress',
                path: /\/keypress/i,
                method: 'post',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req);
                }),
            },
            {
                name: 'launch',
                path: /\/launch\/(.+)/i,
                method: 'post',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req);
                }),
            },
        ];
    }
    makeAppsResponse() {
        const result = '<?xml version="1.0" encoding="UTF-8" ?>\n<apps>';
        const appXml = this.apps.map(app => `<app id=\"${app.id}\" type=\"appl\" version=\"${app.version}\">${app.name}</app>`);
        return result + appXml.join('\n\t') + '\n</apps>';
    }
    makeResponse(request, result) {
        const resultLength = result !== undefined && typeof result === 'string' ? result.length : 0;
        return {
            status: 200,
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': `'${resultLength}'`,
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'text/xml',
                charset: 'utf-8',
            },
            data: result,
        };
    }
}
Roku.emulatorType = 'httpRequestEmulator';
Roku.key = '-O6HYz2n-dDTo5GyjJlX';
